export const generateUrlToQuery = (prefix, query) => {
  const params = new URLSearchParams(query);
  if (prefix) {
    params.append([prefix], query.slug);
  }
  params.delete("slug");

  const queryString = `?${params.toString()}`;

  return queryString;
};
